import {
	HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY,
	HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE,
} from '@atlassian/hub-element-placeholder';

export const getSectionExtensionContents = ({
	header,
	subHeader,
	placeholderTitle,
}: {
	header: string;
	placeholderTitle: string;
	subHeader: string;
}) => [
	{
		type: 'extensionFrame',
		content: [
			{
				type: 'heading',
				attrs: {
					level: 1,
					localId: null,
				},
				content: [
					{
						type: 'text',
						text: `${header}`,
					},
				],
			},
			{
				type: 'paragraph',
				attrs: {
					localId: null,
				},
				content: [
					{
						type: 'text',
						text: `${subHeader}`,
					},
				],
			},
			{
				type: 'paragraph',
				attrs: {
					localId: null,
				},
			},
			{
				type: 'extension',
				attrs: {
					extensionKey: HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY,
					extensionType: HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE,
					parameters: { extensionTitle: placeholderTitle },
					text: null,
					layout: 'default',
					localId: null,
				},
			},
		],
	},
];
